<div class="row w-100" [class.my-5]="hasLegacyIcon(config)">
  <div class="col-12 d-flex flex-column justify-content-center align-items-center">
    @if (config.type === TableEmptyStateType.dsPageMessage) {
      <ds-page-message
        class="table-empty-state-ds-page-message"
        data-test-id="empty-state-ds-page-message"
        [title]="config.title"
        [toggleBody]="!!config.subtitle"
        [setPageMessageVariant]="config.dsPageMessage.variant"
        [pageMessageIcon]="config.dsPageMessage.icon"
        [iconColor]="config.dsPageMessage.iconColor"
        [iconScale]="config.dsPageMessage.iconScale"
        [iconStyle]="config.dsPageMessage.iconStyle"
        [toggleAction]="!!config.dsButton || !!config.button"
        [togglePadding]="false"
        titleHeadingStyle="h3"
      >
        <div ds-page-message-body data-test-id="empty-state-ds-page-message-body">{{ config.subtitle }}</div>
        <div ds-page-message-action class="d-flex justify-content-center">
          @if (config.dsButton) {
            <button
              ds-button
              [variant]="config.dsButton.variant"
              [microActionIcon]="config.dsButton.icon"
              data-test-id="empty-state-button"
              (click)="config.dsButton.onClick($event)"
            >
              {{ config.dsButton.label }}
            </button>
          } @else if (config.button) {
            <a
              ds-button
              [variant]="DsButtonVariants.secondary"
              [routerLink]="config.button.routerLink"
              data-test-id="empty-state-button-link"
            >
              {{ config.button.label }}
            </a>
          }
        </div>
      </ds-page-message>
    } @else {
      @if (config.dsIcon; as iconConfig) {
        <ds-icon
          [class]="{ 'ds-icon-default': iconConfig.hasDefaultDsClass, 'mt-4': true }"
          [icon]="iconConfig.icon"
          [iconStyle]="iconConfig.style"
          [scale]="iconConfig.scale"
          [style.color]="iconConfig.color"
          [style.background]="iconConfig.backgroundColor"
          data-test-id="empty-state-ds-icon"
        ></ds-icon>
      }
      @if (config.iconId) {
        <svg
          [attr.height]="config.iconHeight === undefined ? '60' : config.iconHeight"
          [attr.width]="config.iconWidth === undefined ? '96' : config.iconWidth"
          [attr.fill]="config.iconFill === undefined ? 'black' : config.iconFill"
          aria-hidden="true"
        >
          <use [attr.xlink:href]="'#' + config.iconId"></use>
        </svg>
      }
      @if (config.title) {
        <h3 class="mt-4 mb-2">{{ config.title }}</h3>
      }
      @if (!config.title && config.titleHtml) {
        <h3 class="mt-4 mb-2" [innerHTML]="config.titleHtml"></h3>
      }
      @if (config.subtitle) {
        <p class="mx-4 subtitle pre-line">{{ config.subtitle }}</p>
      }
      @if (config.dsButton) {
        <button
          ds-button
          [variant]="config.dsButton.variant"
          [microActionIcon]="config.dsButton.icon"
          data-test-id="empty-state-button"
          (click)="config.dsButton.onClick($event)"
        >
          {{ config.dsButton.label }}
        </button>
      } @else if (config.button) {
        <a class="btn btn-outline-primary" [routerLink]="config.button.routerLink" data-test-id="empty-state-button-link">
          {{ config.button.label }}
        </a>
      }
    }
  </div>
</div>
